const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSquat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    id: "bench-press-7",
    "data-name": "Flat Color",
    xmlns: "http://www.w3.org/2000/svg",
    className: "icon flat-color",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "secondary",
    d: "M20,10a1,1,0,0,1-1-1V7H5V9A1,1,0,0,1,3,9,1,1,0,0,1,2,8V4A1,1,0,0,1,3,3,1,1,0,0,1,5,3V5H19V3a1,1,0,0,1,2,0,1,1,0,0,1,1,1V8a1,1,0,0,1-1,1A1,1,0,0,1,20,10Z",
    style: {
      fill: "rgb(44, 169, 188)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "primary",
    d: "M19,22H5a1,1,0,0,1,0-2H7V4A1,1,0,0,1,9,4V20h6V4a1,1,0,0,1,2,0V20h2a1,1,0,0,1,0,2Z",
    style: {
      fill: "rgb(0, 0, 0)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquat);
export default __webpack_public_path__ + "static/media/squat.150bfba2df893acdcef5343ba4eb0f6b.svg";
export { ForwardRef as ReactComponent };